import React from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from "react-router-dom";
import * as routes from "../helpers/routes";

// Material-UI imports
import Typography from "@mui/material/Typography";
import { KeyboardArrowLeft } from "@mui/icons-material";

// Third-party library imports
import { Flex } from "reflexbox";

// Local component imports
import HamburgerMenu from "../common/HamburgerMenu";

// Utility/helper imports
import { PRIMARYCOLOR } from "../helpers/ThemeSettings";

const PageHeader = (props) => {
  let navigate = useNavigate();

  return (
    <Flex
      style={{
        flexDirection: 'column',
        alignItems: 'stretch',
        width: '100%',
      }}
    >
      {(props.goBack || props.goHome || props.hamburgerMenu) && (
        <Flex
          style={{
            alignItems: 'center',
            justifyContent: 'space-between',
            width: '100%',
          }}
        >
          <Flex style={{ alignItems: 'center', minWidth: '60px', gap: '8px' }}>
            {props.goBack && (
              <Flex
                style={{ alignItems: 'center', cursor: 'pointer' }}
                onClick={() => navigate(-1)}
              >
                <KeyboardArrowLeft /> Return
              </Flex>
            )}
            {props.goHome && (
              <Flex
                style={{ alignItems: 'center', cursor: 'pointer' }}
                onClick={() =>
                  props.onGoHome ? props.onGoHome() : navigate(routes.HOME)
                }
              >
                <KeyboardArrowLeft /> {props.goHomeLabel ?? 'Home'}
              </Flex>
            )}
          </Flex>
          {props.hamburgerMenu ? (
            <Flex style={{ minWidth: '60px', justifyContent: 'flex-end' }}>
              <HamburgerMenu currentCourse={props.currentCourse} />
            </Flex>
          ) : (
            <div style={{ minWidth: '60px' }} />
          )}
        </Flex>
      )}

      {props.title && (
        <Flex
          style={{
            justifyContent: 'center',
            paddingBottom: '20px',
            paddingTop: '5px',
            minWidth: '150px',
          }}
        >
          <Typography
            variant={'h5'}
            style={{
              color: PRIMARYCOLOR,
              padding: '4px 16px',
              width: '100%',
              textAlign: 'center',
              fontWeight: 'bold'
            }}
          >
            {props.title}
          </Typography>
        </Flex>
      )}
    </Flex>
  );
};

PageHeader.propTypes = {
  goBack: PropTypes.bool,
  goHome: PropTypes.bool,
  goHomeLabel: PropTypes.string,
  onGoHome: PropTypes.func,
  hamburgerMenu: PropTypes.bool,
  title: PropTypes.any,
  currentCourse: PropTypes.string,
};

export default PageHeader;